/* @flow */
/* eslint-env es6,browser */

import _idpbase from './idpbase';
import { IDP_COOKIE_EXPIRY_DAYS, IDP_33ACROSS } from './idpconstants';
import { isJSONSupported, isDNT } from '../utils/browserutil';
import { fetchJSON, isFetchSupported } from '../utils/fetch';
import { getCookie, setCookie } from '../utils/cookie';
import { isCCPAOptedOut, getCCPA } from '../utils/ccpautils';
import storage from '../utils/storage';
import { logError } from '../utils/logger';

const _33ACROSS_ID_KEY = '33acrossId';
const _33ACROSS_ID_KEY_LAST = '33acrossId_last';
const REFRESH_SECONDS = 8 * 3600;
const DEFAULT_TIMEOUT_MS = 2 * 1000;

class _33acrossid extends _idpbase {
  _bInited: boolean;

  constructor(name: string) {
    super(name);
    this._bInited = false;
  }

  _fetchFromCacheAndShouldRefresh(): boolean {
    let bRet = true;
    // get ID & last
    const storageId = storage.get(_33ACROSS_ID_KEY);
    const cookieId = getCookie(_33ACROSS_ID_KEY);
    const id = storageId || cookieId || '';
    const storageLast = storage.get(_33ACROSS_ID_KEY_LAST);
    const cookieLast = getCookie(_33ACROSS_ID_KEY_LAST);
    const last = storageLast || cookieLast || '';

    if (id.length === 0) {
      // we need to fetch now.
      return bRet;
    }
    this._cachedID = id;
    // We have some ID. Let's see if we can use it
    if (last.length === 0) {
      // let's fetch once
      return bRet;
    }
    // check if stored value is within refresh timeframe
    const storedDate = new Date(last);
    bRet =
      storedDate && Date.now() - storedDate.getTime() > REFRESH_SECONDS * 1000;
    return bRet;
  }

  updateConfig({
    url = '',
    pid = '',
    expires = IDP_COOKIE_EXPIRY_DAYS
  }: _perIDPConfig) {
    super.updateConfig({ url, pid, expires });
    if (
      pid.length === 0 ||
      this._bInited ||
      !isFetchSupported() ||
      isCCPAOptedOut() ||
      isDNT() ||
      !isJSONSupported()
    ) {
      return;
    }

    // initialize here
    this._bInited = true;
    if (!this._fetchFromCacheAndShouldRefresh()) {
      return;
    }
    // refresh the ID here
    // now fetch it from server
    const opt = {
      data: {
        pid: this._pid,
        gdpr: 0,
        // eslint-disable-next-line camelcase
        us_privacy: getCCPA()
      },
      logPrefix: this._name,
      timeout: DEFAULT_TIMEOUT_MS,
      format: 'json'
    };
    const req = {
      credentials: 'include'
    };
    fetchJSON(this._url, opt, req).then(
      res => {
        const {
          succeeded = false,
          error = '',
          data: { envelope = '' } = {}
        } = res;
        if (!succeeded || error.length > 0) {
          logError(`${this._name} Failed to get userID: ${error || ''}`);
          return '';
        }

        // cache it
        storage.store(_33ACROSS_ID_KEY, envelope);
        setCookie(_33ACROSS_ID_KEY, envelope);
        const now = new Date().toUTCString();
        storage.store(_33ACROSS_ID_KEY_LAST, now);
        setCookie(_33ACROSS_ID_KEY_LAST, now);
        this._cachedID = envelope;
        return envelope;
      },
      error => {
        logError(`${this._name} Failed to get userID: ${error || ''}`);
      }
    );
  }
}
const idp: _33acrossid = new _33acrossid(IDP_33ACROSS);
export default idp;
